import { Component, OnInit, OnDestroy, Inject } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { GeneralService } from '@app/core/http';
import { UntilDestroy, untilDestroyed } from '@ngneat/until-destroy';
import { AuthService } from 'ngx-venus';

@UntilDestroy()
@Component({
  selector: 'app-pbl-redirect',
  templateUrl: './pbl-redirect.component.html',
})
export class PblRedirectComponent implements OnInit, OnDestroy {
  constructor(
    public route: ActivatedRoute,
    private generalService: GeneralService,
    private authService: AuthService,
    public router: Router // @Inject('Window') private window: Window
  ) {}

  ngOnInit() {
    this.authService.flush();
    const id = this.route.snapshot.paramMap.get('id') || '';
    this.generalService
      .getPayByLinkUrl(id)
      .pipe(untilDestroyed(this))
      .subscribe((response) => {
        if (response.tinyRedirectUrl) {
          window.location.href = response.tinyRedirectUrl;
        } else {
          this.router.navigate(['401']);
        }
      });
  }

  ngOnDestroy() {}
}
